import { createAction } from '@mews-framework/redux';
import { LogData } from '../../../services';

export const ERROR_LOGGED = '@@sentry/ERROR_LOGGED';

export const logSentryError = ({ error, extra = {} }: LogData) => createAction(ERROR_LOGGED, { error, extra });

export type LogSentryErrorAction = ReturnType<typeof logSentryError>;
